import { createSlice, current } from "@reduxjs/toolkit";

const initialState = {
  idPlay: null,
  currentTab:""
};
const videoSlice = createSlice({
  name: "video",
  initialState,
  reducers: {
    setIdPlay: (state,{payload}) => {
      state.idPlay = payload;
    },
    setCurrentTab: (state,{payload}) => {
      state.currentTab = payload;
    },
    
  },

  
});

export const { setIdPlay,setCurrentTab } = videoSlice.actions;

export default videoSlice.reducer;
